import React from 'react';
import { ChevronLeft, ChevronRight } from '@gravity-ui/icons';
import './NumberedPagination.css';

export const buildPageWindow = (page, pageCount) => {
  if (pageCount <= 5) return Array.from({ length: pageCount }, (_, i) => i + 1);
  const pages = new Set([1, pageCount, page - 1, page, page + 1]);
  const sorted = [...pages].filter((p) => p >= 1 && p <= pageCount).sort((a, b) => a - b);
  const result = [];
  sorted.forEach((p, i) => {
    if (i > 0 && p - sorted[i - 1] > 1) result.push('gap');
    result.push(p);
  });
  return result;
};

export default function NumberedPagination({
  total,
  limit,
  offset,
  onOffsetChange,
  onLimitChange,
  pageSizes = [10, 25, 50, 100],
  disabled = false,
}) {
  if (!total || total <= 0 || !limit || limit <= 0) return null;

  const pageCount = Math.max(1, Math.ceil(total / limit));
  const page = Math.min(pageCount, Math.floor(Math.max(0, offset) / limit) + 1);
  const from = (page - 1) * limit + 1;
  const to = Math.min(page * limit, total);
  const sizes = pageSizes.includes(limit) ? pageSizes : [...pageSizes, limit].sort((a, b) => a - b);

  return (
    <div className="npager">
      <span className="npager-range">{`Показано ${from}–${to} из ${total}`}</span>
      <div className="npager-controls">
        {onLimitChange && (
          <label className="npager-size">
            <span>На странице</span>
            <select
              value={limit}
              disabled={disabled}
              onChange={(e) => onLimitChange(Number(e.target.value))}
            >
              {sizes.map((n) => <option key={n} value={n}>{n}</option>)}
            </select>
          </label>
        )}
        <nav className="npager-pages" aria-label="Страницы">
          <button
            type="button"
            className="npager-btn"
            disabled={disabled || page <= 1}
            onClick={() => onOffsetChange((page - 2) * limit)}
          >
            <ChevronLeft width={16} height={16} aria-hidden="true" />
            Назад
          </button>
          {buildPageWindow(page, pageCount).map((item, i) => (
            item === 'gap' ? (
              <span key={`gap-${i}`} className="npager-gap">…</span>
            ) : (
              <button
                key={item}
                type="button"
                className={`npager-btn npager-num${item === page ? ' is-current' : ''}`}
                aria-current={item === page ? 'page' : undefined}
                disabled={disabled}
                onClick={() => onOffsetChange((item - 1) * limit)}
              >
                {item}
              </button>
            )
          ))}
          <button
            type="button"
            className="npager-btn"
            disabled={disabled || page >= pageCount}
            onClick={() => onOffsetChange(page * limit)}
          >
            Вперёд
            <ChevronRight width={16} height={16} aria-hidden="true" />
          </button>
        </nav>
      </div>
    </div>
  );
}
